import { mypage_api_config, queryParam } from "utils/APIConfig";
import { ACTION_GET } from "utils/AxiosActions";

// ログイン中ユーザー本人の購買履歴（対象ユーザーはサーバー側でトークンから決まる）
export const Get_Orders = async ({ page = 1, size = 5 } = {}) => {
    const _conf = await mypage_api_config();
    const url = `${_conf.endpoints.purchases_url}?${queryParam({ page, size })}`;
    return ACTION_GET(url, _conf.config);
}
